module.exports = "/assets/99eae15176b9d5f8c0ef80ce07de36cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ukrail/web2mobile_Step2.png
// module id = 713
// module chunks = 0